import React from 'react';
import PropTypes from 'prop-types';
import TwoDimension from '../../assets/visualEffect2d.svg';
import ThirdDimension from '../../assets/visualEffect3d.svg';
import ThirtyThreeMM from '../../assets/visualEffect35mm.svg';
import FourK from '../../assets/visualEffect4k.svg';

const VisualEffect = ({ effect }) => {
  switch (effect) {
    case 'visual-effect-2d':
      return <TwoDimension key={effect} />;
    case 'visual-effect-3d':
      return <ThirdDimension key={effect} />;
    case 'visual-effect-4k':
      return <FourK key={effect} />;
    case 'visual-effect-35mm':
      return <ThirtyThreeMM key={effect} />;
    default:
      return <TwoDimension key={effect} />;
  }
};

VisualEffect.propTypes = {
  effect: PropTypes.string.isRequired,
};

export default VisualEffect;
